import React, { useState } from "react";
import "./ItineraryDetails.css";
import Skeleton from "react-loading-skeleton";

function ListingSkeleton(props) {
  return (
    <div
      className="activityCardWrapper selected "
      data-testid="activity-listing"
    >
      <div className="activityPanel_leftContainer">
        <div className="imageWrapper">
          <div className="listing-carousel">
            <div className="slick-slider slick-initialized">
              <div className="slick-list">
                <div
                  className="slick-track"
                  style={{
                    width: "208px",
                    opacity: 1,
                    transform: "translate3d(0px, 0px, 0px)",
                  }}
                >
                  <div
                    data-index="0"
                    className="slick-slide slick-active slick-current"
                    tabindex="-1"
                    aria-hidden="false"
                    style={{
                      outline: "none",
                      width: "208px",
                    }}
                  >
                    <div>
                      <div
                        tabindex="-1"
                        style={{
                          width: "100%",
                          display: "inline-block",
                        }}
                      >
                        <div className="imageLoaderContainer ">
                          <Skeleton className="imageSkeleton" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="activityPanel_rightContainer">
        <div className="flex badges">
          <div className="hotelBadgeWrapper"></div>
        </div>
        <div className="flex">
          <div className="flex column">
            <h3 className="text-Color" style={{ color: "gray", width: 300 }}>
              <Skeleton />
            </h3>
            <p
              className="address"
              style={{ color: "gray", width: 300, marginTop: 5 }}
            >
              <Skeleton />
            </p>
            <p
              className="address"
              style={{ color: "gray", width: 300, marginTop: 5 }}
            >
              <Skeleton />{" "}
            </p>
            <p
              className="address"
              style={{ color: "gray", width: 300, marginTop: 5 }}
            >
              <Skeleton />{" "}
            </p>
            <p
              className="address"
              style={{ color: "gray", width: 300, marginTop: 5 }}
            >
              <Skeleton />{" "}
            </p>
          </div>
          <div className="charges font20" style={{ bottom: "38px" }}>
            <p  style={{ color: "gray", width: "100px" }}>
              <Skeleton />
            </p>
            <p className="address" style={{ color: "gray", width: "100px", marginTop: 5 }}>
              <Skeleton />
            </p>
            <p   className="address" style={{ color: "gray", width: "100px", marginTop: 5 }}>
              <Skeleton />
            </p>
            <p className="address" style={{ color: "gray", width: "100px", marginTop: 5 }}>
              <Skeleton />
            </p>
          </div>
        </div>
        <div className="activityPanel_rightContainerFooter flex">
          <div className="selectedButtonWrapper">
            <span className="removeBtn font11">
              <p style={{ width: "100px" }}>
                <Skeleton />
              </p>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ListingSkeleton;
